import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  tableHead: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '4fr 4fr 4fr 4fr 4fr 4fr 1.25fr',
    columnGap: 5,
    '& p': { color: theme.palette.text.secondary },
    alignItems: 'center',
    padding: '6px 0 6px 12px',
    marginBottom: 4,
    marginTop: 4,
    backgroundColor: theme.palette.background.paper,
    borderRadius: 12
  }
}))

export default useStyles
